import { localizeWithPath } from 'vscode/vscode/vs/nls';
import { Extensions } from 'vscode/vscode/vs/platform/quickinput/common/quickAccess';
import { Registry } from 'vscode/vscode/vs/platform/registry/common/platform';
import { HelpQuickAccessProvider } from '../../../../platform/quickinput/browser/helpQuickAccess.js';
import { ViewQuickAccessProvider, OpenViewPickerAction, QuickAccessViewPickerAction } from './viewQuickAccess.js';
import { CommandsQuickAccessProvider, ShowAllCommandsAction, ClearCommandHistoryAction } from './commandsQuickAccess.js';
import { MenuRegistry, MenuId, registerAction2 } from 'vscode/vscode/vs/platform/actions/common/actions';
import { ContextKeyExpr } from 'vscode/vscode/vs/platform/contextkey/common/contextkey';
import { inQuickPickContext, getQuickNavigateHandler } from 'vscode/vscode/vs/workbench/browser/quickaccess';
import { KeybindingsRegistry } from 'vscode/vscode/vs/platform/keybinding/common/keybindingsRegistry';
import { EditorContextKeys } from 'vscode/vscode/vs/editor/common/editorContextKeys';

const _moduleId = "vs/workbench/contrib/quickaccess/browser/quickAccess.contribution";
const quickAccessRegistry = ( (Registry.as(Extensions.Quickaccess)));
quickAccessRegistry.registerQuickAccessProvider({
    ctor: HelpQuickAccessProvider,
    prefix: HelpQuickAccessProvider.PREFIX,
    placeholder: ( localizeWithPath(
        _moduleId,
        0,
        "Type '{0}' to get help on the actions you can take from here.",
        HelpQuickAccessProvider.PREFIX
    )),
    helpEntries: [{
            description: ( localizeWithPath(_moduleId, 1, "Show all Quick Access Providers")),
            commandCenterOrder: 70,
            commandCenterLabel: ( localizeWithPath(_moduleId, 2, 'More'))
        }]
});
quickAccessRegistry.registerQuickAccessProvider({
    ctor: ViewQuickAccessProvider,
    prefix: ViewQuickAccessProvider.PREFIX,
    contextKey: 'inViewsPicker',
    placeholder: ( localizeWithPath(
        _moduleId,
        3,
        "Type the name of a view, output channel or terminal to open."
    )),
    helpEntries: [{ description: ( localizeWithPath(_moduleId, 4, "Open View")), commandId: OpenViewPickerAction.ID }]
});
quickAccessRegistry.registerQuickAccessProvider({
    ctor: CommandsQuickAccessProvider,
    prefix: CommandsQuickAccessProvider.PREFIX,
    contextKey: 'inCommandsPicker',
    placeholder: ( localizeWithPath(_moduleId, 5, "Type the name of a command to run.")),
    helpEntries: [{ description: ( localizeWithPath(_moduleId, 6, "Show and Run Commands")), commandId: ShowAllCommandsAction.ID, commandCenterOrder: 20 }]
});
MenuRegistry.appendMenuItem(MenuId.MenubarViewMenu, {
    group: '1_open',
    command: {
        id: ShowAllCommandsAction.ID,
        title: ( localizeWithPath(_moduleId, 7, "&&Command Palette..."))
    },
    order: 1
});
MenuRegistry.appendMenuItem(MenuId.MenubarHelpMenu, {
    group: '1_welcome',
    command: {
        id: ShowAllCommandsAction.ID,
        title: ( localizeWithPath(_moduleId, 8, "Show All Commands"))
    },
    order: 2
});
MenuRegistry.appendMenuItem(MenuId.MenubarViewMenu, {
    group: '1_open',
    command: {
        id: OpenViewPickerAction.ID,
        title: ( localizeWithPath(_moduleId, 9, "&&Open View..."))
    },
    order: 2
});
MenuRegistry.appendMenuItem(MenuId.MenubarGoMenu, {
    group: '5_infile_nav',
    command: {
        id: 'workbench.action.gotoLine',
        title: ( localizeWithPath(_moduleId, 10, "Go to &&Line/Column..."))
    },
    order: 1
});
MenuRegistry.appendMenuItem(MenuId.GlobalActivity, {
    group: '1_command',
    command: {
        id: ShowAllCommandsAction.ID,
        title: ( localizeWithPath(_moduleId, 11, "Command Palette..."))
    },
    order: 1
});
MenuRegistry.appendMenuItem(MenuId.EditorContext, {
    group: 'z_commands',
    when: ( (EditorContextKeys.editorSimpleInput.toNegated())),
    command: {
        id: ShowAllCommandsAction.ID,
        title: ( localizeWithPath(_moduleId, 11, "Command Palette...")),
    },
    order: 1
});
registerAction2(ClearCommandHistoryAction);
registerAction2(ShowAllCommandsAction);
registerAction2(OpenViewPickerAction);
registerAction2(QuickAccessViewPickerAction);
const inViewsPickerContextKey = 'inViewsPicker';
const inViewsPickerContext = ( (ContextKeyExpr.and(
    inQuickPickContext,
     (ContextKeyExpr.has(inViewsPickerContextKey))
)));
const viewPickerKeybinding = QuickAccessViewPickerAction.KEYBINDING;
const quickAccessNavigateNextInViewPickerId = 'workbench.action.quickOpenNavigateNextInViewPicker';
KeybindingsRegistry.registerCommandAndKeybindingRule({
    id: quickAccessNavigateNextInViewPickerId,
    weight: 200  + 50,
    handler: getQuickNavigateHandler(quickAccessNavigateNextInViewPickerId, true),
    when: inViewsPickerContext,
    primary: viewPickerKeybinding.primary,
    linux: viewPickerKeybinding.linux,
    mac: viewPickerKeybinding.mac
});
const quickAccessNavigatePreviousInViewPickerId = 'workbench.action.quickOpenNavigatePreviousInViewPicker';
KeybindingsRegistry.registerCommandAndKeybindingRule({
    id: quickAccessNavigatePreviousInViewPickerId,
    weight: 200  + 50,
    handler: getQuickNavigateHandler(quickAccessNavigatePreviousInViewPickerId, false),
    when: inViewsPickerContext,
    primary: viewPickerKeybinding.primary | 1024 ,
    linux: viewPickerKeybinding.linux,
    mac: {
        primary: viewPickerKeybinding.mac.primary | 1024
    }
});
